module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/dbd143918003892a87ae09758a5243e4.png";